import ascending from "./ascending";
import number from "./number";
import quantile from "./quantile";
export default function (array, f) {
  var numbers = [],
      n = array.length,
      a,
      i = -1;

  if (f == null) {
    while (++i < n) {
      if (!isNaN(a = number(array[i]))) numbers.push(a);
    }
  } else {
    while (++i < n) {
      if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
    }
  }

  return quantile(numbers.sort(ascending), 0.5);
}